import { render, staticRenderFns } from "./form.vue?vue&type=template&id=4b6cd03a&scoped=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"
import style0 from "./form.vue?vue&type=style&index=0&id=4b6cd03a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6cd03a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6cd03a')) {
      api.createRecord('4b6cd03a', component.options)
    } else {
      api.reload('4b6cd03a', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=4b6cd03a&scoped=true", function () {
      api.rerender('4b6cd03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/pledge-form/form.vue"
export default component.exports